import { z } from "zod";

export const StartExamRequestSchema = z.object({
  mode: z.enum(["full", "deel-1", "deel-2", "deel-3", "deel-4"]),
  skin: z.enum(["ember", "duo"]).optional(),
  focusMode: z.boolean().optional(),
});
export type StartExamRequest = z.infer<typeof StartExamRequestSchema>;

export const QuestionShapeSchema = z.object({
  id: z.string(),
  part: z.number().int().min(1).max(4),
  questionIdx: z.number().int().min(0),
  promptText: z.string(),
  imagePrompts: z.array(z.string()).nullable().optional(),
  imageUrls: z.array(z.string()).nullable().optional(),
  videoUrl: z.string().nullable().optional(),
});

export const StartExamResponseSchema = z.object({
  sessionId: z.string(),
  questions: z.array(QuestionShapeSchema),
});
export type StartExamResponse = z.infer<typeof StartExamResponseSchema>;

export const TurnRequestSchema = z.object({
  sessionId: z.string(),
  questionId: z.string(),
  part: z.number().int().min(1).max(4),
  questionIdx: z.number().int().min(0),
});
export type TurnRequest = z.infer<typeof TurnRequestSchema>;

export const TurnScoreShapeSchema = z.object({
  ad: z.number().int().min(0).max(3),
  wo: z.number().int().min(0).max(2),
  gr: z.number().int().min(0).max(2),
  vl: z.number().int().min(0).max(2),
  helderheid: z.number().int().min(0).max(1).nullable(),
  uit: z.number().int().min(0).max(2),
  uitNotes: z.string(),
  feedbackMd: z.string(),
});
export type TurnScoreShape = z.infer<typeof TurnScoreShapeSchema>;
